import { SortingDirection } from 'api/clients/FilesViewsClient'
import { DefaultType, Property } from 'api/clients/PropertyClient'
import { useProperties } from 'hooks/queries/companies/properties/useProperties'
import { useFiles } from 'hooks/queries/finder/useFiles'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useUploadsProject } from 'hooks/useUploadsProject'

export const useUploads = () => {
  const workspaceId = useCurrentWorkspaceId()
  const properties = useProperties({ default: true }, { staleTime: 0 })
  const createdProperty = properties.data?.data.properties.find((p: Property) => p.default_type === DefaultType.Created)

  const uploadsProject = useUploadsProject(workspaceId)
  const uploadsProjectId = uploadsProject?.data?.project?.id || null

  const uploadsProjectQuery = useFiles(
    {
      location: uploadsProjectId || '',
      workspaceId,
      query: {
        items: 20,
        skip_projects: true,
        sorting_direction: SortingDirection.Descending,
        sorting_property_id: createdProperty?.id,
      },
    },
    { enabled: Boolean(uploadsProjectId) },
  )

  return uploadsProjectQuery
}
